import { Gamepad2, Radio } from 'lucide-react';
import { navigate } from '@/hooks/useRouter';
import lobbyBg from '@/assets/home/lobby-bg.svg';

export default function HomeHero() {
  return (
    <section className="relative overflow-hidden px-4 pt-4 pb-3">
      <img
        src={lobbyBg}
        alt=""
        aria-hidden="true"
        className="absolute inset-x-0 top-0 h-[288px] w-full object-cover opacity-90"
      />
      <div className="home-arcade-bg absolute inset-0" />
      <div className="absolute inset-x-0 top-0 h-[288px] bg-[linear-gradient(180deg,rgba(3,4,18,0.02)_0%,rgba(5,7,28,0.46)_58%,#06071c_100%)]" />
      <div className="absolute inset-x-4 top-[82px] h-px bg-gradient-to-r from-transparent via-cyan-200/55 to-transparent shadow-[0_0_18px_rgba(103,232,249,0.5)]" />
      <div className="absolute right-7 top-5 h-16 w-16 rounded-full bg-fuchsia-400/20 blur-2xl" />

      <div className="relative flex items-start justify-between gap-3">
        <div>
          <div className="flex items-center gap-2 text-sm font-black text-white/88">
            <Radio size={17} className="text-amber-200" />
            移动游戏大厅
          </div>
          <h1 className="mt-1 text-[34px] font-black leading-none tracking-normal text-white drop-shadow-[0_4px_12px_rgba(0,0,0,0.55)]">
            游戏首页
          </h1>
        </div>
        <button
          type="button"
          onClick={() => navigate('/profile')}
          className="home-premium-button flex h-14 w-14 items-center justify-center rounded-[22px] border border-fuchsia-100/45 bg-gradient-to-br from-fuchsia-300 via-violet-600 to-[#14113f] text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.45),inset_0_-12px_20px_rgba(0,0,0,0.28),0_0_26px_rgba(168,85,247,0.68),0_10px_22px_rgba(2,6,23,0.38)] transition-transform active:scale-95"
        >
          <Gamepad2 size={25} />
        </button>
      </div>
    </section>
  );
}
